import dayjs from 'dayjs'
import React, { useState } from 'react'
import dateFields from '../../../../utils/constants/widgets/dateFields'
import dateTimeFields from '../../../../utils/constants/widgets/dateTimeFields'

const GlobalTooltip = (props) => {
    const { hoveredPoint, tooltipLabels, coordinate } = props
    if (
        !hoveredPoint ||
        Math.abs(hoveredPoint.x - coordinate.x) > 10 ||
        Math.abs(hoveredPoint.y - coordinate.y) > 10
    )
        return null

    return (
        <foreignObject
            x={hoveredPoint.cx + 12}
            y={hoveredPoint.cy - 40}
            width={1}
            height={1}
            style={{
                overflow: 'visible',
                pointerEvents: 'none',
            }}
        >
            <CustomScatterTooltip
                payload={hoveredPoint.payload}
                tooltipLabels={tooltipLabels}
            />
        </foreignObject>
    )
}

const CustomScatterTooltip = ({ payload, tooltipLabels }) => {
    for (let prop in payload) {
        if (dateTimeFields.includes(prop) || dateFields.includes(prop)) {
            payload[prop] = dayjs(payload[prop]).format('MM/DD/YYYY HH:mm')
        }
    }

    return (
        <div
            className="recharts-default-tooltip customTooltip"
            style={{
                width: 'fit-content',
                minWidth: '200px',
                backgroundColor: 'white',
                zIndex: 1000,
            }}
        >
            <ul className="recharts-tooltip-item-list customTooltipList">
                {tooltipLabels
                    .filter((x) => payload && payload[x] !== 'No tooltip value')
                    .map((x, idx) => (
                        <li style={{ color: payload.color }} key={idx}>
                            <span className="customTooltipItemName">
                                <b>{x}:</b>{' '}
                            </span>
                            <span className="customTooltipItemValue">
                                {payload[x]}
                            </span>
                        </li>
                    ))}
            </ul>
        </div>
    )
}

export { GlobalTooltip }
export default CustomScatterTooltip
